/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Wrapper Caja del tab bar compartido — fija testID `caja.tab.*`.
 */
import React from 'react';
import { type ViewStyle } from 'react-native';
import {
  UnderlineTabBar,
  type UnderlineTabOption,
} from '../../../shared/ui/UnderlineTabBar';

export type CashUnderlineTabOption<T extends string> = UnderlineTabOption<T>;

type Props<T extends string> = {
  options: CashUnderlineTabOption<T>[];
  value: T;
  onChange: (value: T) => void;
  style?: ViewStyle;
  fillTabs?: boolean;
};

export function CashUnderlineTabBar<T extends string>(props: Props<T>) {
  return <UnderlineTabBar {...props} testIDPrefix="caja.tab" />;
}
